export default {"src":"/_next/static/media/checkmarkYellow.9c8a51e4.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};